import { render, staticRenderFns } from "./HabitDropdown.vue?vue&type=template&id=3e4e06f6&scoped=true"
import script from "./HabitDropdown.vue?vue&type=script&lang=js"
export * from "./HabitDropdown.vue?vue&type=script&lang=js"
import style0 from "./HabitDropdown.vue?vue&type=style&index=0&id=3e4e06f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e06f6",
  null
  
)

export default component.exports